import $ from "jquery";

export default {

    methods: {
        /**
         * Half the amount of padding for the spacer on the screen smaller than 475px
         */
        responsiveSpacers() {
            let spacers = document.getElementsByClassName('spacer');
            for (let spacer of spacers) {
                let padding = spacer.style.padding;
                let array = padding.split('px');
                let newPadding = parseFloat(array[0]) / 2;
                spacer.style.padding = newPadding + 'px';
            }
        },

        accordionToggle(event) {
            let el = $(event.currentTarget);

            if (el.hasClass('open')) {
                el.removeClass('open');
                el.find('.accordion__list-item-text').slideUp(function () {
                   //
                });
            } else {
                el.addClass('open');
                el.find('.accordion__list-item-text').slideDown(function () {
                    //
                });
            }
        }
    }
}
